import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../redux/userSlice';
import eventReducer from '../redux/eventSlice';
import dashboardReducer from '../redux/dashboardSlice';
import categoryReducer from '../redux/categorySlice';
import { apiMiddleware } from '../redux/middleware/apiMiddleware';

export const store = configureStore({
    reducer: {
        user: userReducer,
        event: eventReducer,
        dashboard: dashboardReducer,
        category: categoryReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiMiddleware),
});

